import React from "react";
import PropTypes from "prop-types";

const appCfg = require("../../config");

class Logo extends React.Component {
    render() {
        let state = this.props.store.getState();

        let width = state && "questionSet" in state && "logoWidth" in state.questionSet ? state.questionSet.logoWidth : "auto";

        return (<img style={{width:width}} className="logoImage" 
            src={
                state && "questionSet" in state && "logoImage" in state.questionSet
                    ? appCfg.customerlogoUrlPrefix + "/" + state.questionSet.logoImage
                    : appCfg.customerlogoUrlPrefix + "/custImages/Attestiv/attestiv_logo.png" // this is a fallback
            }
            alt="Customer Logo"
        />);
    }
}

Logo.contextTypes = {
    store: PropTypes.object
};

export default Logo;
